import { api } from "../..";
import { ApiConfig } from "../../ApiConfig";

const baseURL = ApiConfig.baseApi;

const getHeaders = () => {
  const token = localStorage.getItem("accessToken");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const communicationService = {
  getGroups: async () => {
    const url = `${baseURL}communication/groups`;
    return api.get(url, null, getHeaders());
  },

  send: async (payload) => {
    const url = `${baseURL}communication/send`;
    return api.post(url, payload, getHeaders());
  },

  getHistory: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.channel) queryParams.append("channel", params.channel);
    if (params.status) queryParams.append("status", params.status);

    const queryString = queryParams.toString();
    const url = `${baseURL}communication/history${queryString ? `?${queryString}` : ""}`;
    return api.get(url, null, getHeaders());
  },

  getHistoryDetails: async (id) => {
    const url = `${baseURL}communication/history/${id}`;
    return api.get(url, null, getHeaders());
  },

  searchUsers: async (search) => {
    const url = `${baseURL}admin/search?search=${encodeURIComponent(search)}`;
    return api.get(url, null, getHeaders());
  },

  createGroup: async (payload) => {
    const url = `${baseURL}communication/group`;
    return api.post(url, payload, getHeaders());
  },

  updateGroup: async (id, payload) => {
    const url = `${baseURL}communication/group/${id}`;
    return api.put(url, payload, getHeaders());
  },
};

export default communicationService;
